import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import { AppButton } from '@helpers/button/button';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

/**
 * Componente que renderiza un botón con un icono y un tooltip o un texto (opcional).
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button',
  imports: [ButtonModule, TooltipModule],
  template: `

<p-button
  [icon]="data().icon ? 'pi ' + data().icon : ''"
  [label]="data().label ?? ''"
  [loading]="loading()"
  [size]="'small'"
  [disabled]="disabled()"
  [text]="iconOnly()"
  [styleClass]="'rounded-2xl'"
  pTooltip="{{ data().tooltip ?? '' }}"
  tooltipPosition="top"
  [severity]="severity()"
></p-button>

  `,
  styles: ``
})
export class AppButtonComponent {
  /**
   * Datos del botón.
   */
  data = input.required<AppButton>();

  /**
   * Indica si el botón está cargando.
   */
  loading = input<boolean>(false);

  /**
   * Indica si el botón está deshabilitado.
   */
  disabled = input<boolean>(false);

  /**
   * Indica la accion del botón.
   */
  severity = input<ButtonSeverity>('primary');

  /**
   * Indica si el botón solo contiene un icono.
   */
  iconOnly = computed(() => !this.data().label);

  /**
   * Devuelve el nombre del botón.
   */
  name = computed(() => this.data().id);
}
